



























import { Component, Prop, Vue } from 'vue-property-decorator';

import { DailyReport } from '@/models/dailyReport.model';
import IndexPageDailyReportListItem from '@/pages/index/pages/index/components/IndexPageDailyReportListItem.vue';
import { DailyReportStore } from '@/store/dailyReport';

@Component({
  components: {
    IndexPageDailyReportListItem,
  },
})
export default class IndexPageDailyReportList extends Vue {

  @Prop() isTemperatureShown!: boolean;
  @Prop() value!: DailyReport[];

  @DailyReportStore.Bind.State isTankFieldsShown!: DailyReportStore.State<'isTankFieldsShown'>;

  get numTanks() {
    if (this.value) {
      return Math.max(...this.value.map(m => m.tanks.length));
    }
    return 0;
  }

  get overShorts() {
    return this.value.reduce((result, today, index) => {
      const yesterday = index > 0 ? this.value[index - 1] : null;
      const value = (yesterday && today.volume !== null && today.deliveries !== null && today.sales !== null && yesterday.volume !== null)
        ? Math.round(today.volume - today.deliveries + today.sales - yesterday.volume)
        : null;

      result[today.date] = value;
      return result;
    }, {});
  }

}
